import { FC, invalidateQuery } from '../../Services'
import { DateTime } from 'luxon'

export const createNewConfig = async (config) => {
  try {
    await FC.service('configs').create(config)
    window.growl.show({
      severity: 'success',
      summary: 'Creazione nuova config',
      detail: 'Config creata correttamente.'
    })
    return true
  } catch (error) {
    console.error('Errore durante la creazione dell\'config:', error)
    window.growl.show({
      severity: 'error',
      summary: 'Errore',
      detail: 'Creazione dell\'config non riuscita.'
    })
    return false
  }
}

export const onCellEditComplete = async (e, loggedInUser) => {
  const { rowData, newValue, field } = e
  const editData = { lastEditedBy: loggedInUser.username, lastEdited: DateTime.now().toISO() }

  if (field === 'name') {
    rowData[field] = newValue
    await FC.service('configs').patch(rowData._id, { name: newValue, ...editData })
    invalidateQuery('configs')
  } else {
    rowData[field] = newValue
  }
}

export const clearFields = (setConfigAgencyId, setConfigName) => {
  setConfigAgencyId('')
  setConfigName('')
}

export const createConfig = async (configName, configAgencyId, configs, loggedInUser, setConfigAgencyId, setConfigName) => {
  const isDuplicate = configs.some((item) => item.name === configName && item.agencyId === configAgencyId)
  if (!configName || isDuplicate) {
    if (isDuplicate) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Config già presente' })
    } else {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Inserisci il nome dell\'agenzia' })
    }
    return false
  }

  const defaultFilters = [
    { path: 'C:\\Boffice', fileNameFiltersToExclude: [], fileExtensionsToInclude: ['mir', 'MIR', 'CN*'], localSilentBlacklist: [], forwardingRules: [], inclusionRegex: { regex: '.*\\.(mir|MIR|CN.*)$', flags: '' }, docType: 'MIR', backupPath: 'C:\\copiatkt\\' },
    { path: 'C:\\spl', fileNameFiltersToExclude: [], fileExtensionsToInclude: ['PNR', 'pnr', 'FIL'], localSilentBlacklist: [], forwardingRules: [], inclusionRegex: { regex: '.*\\.(PNR|pnr|FIL)$', flags: '' }, docType: 'SBR', backupPath: 'C:\\copiatkt\\' },
    { path: 'C:\\Air', fileNameFiltersToExclude: [], fileExtensionsToInclude: ['M01', 'M02', 'M03', 'M04', 'M05', 'M06', 'M07', 'M08', 'M09', 'M10', 'M11', 'M12', 'm01', 'm02', 'm03', 'm04', 'm05', 'm06', 'm07', 'm08', 'm09', 'm10', 'm11', 'm12', 'tkt' ], localSilentBlacklist: [], forwardingRules: [], inclusionRegex: { regex: '.*\\.(m|M)(\\d{1,2})(\\d{1,2})$', flags: '' }, docType: 'AMA', backupPath: 'C:\\copiatkt\\' },
    { path: 'C:\\Pico', fileNameFiltersToExclude: [], fileExtensionsToInclude: ['xml', 'XML'], localSilentBlacklist: [], forwardingRules: [], inclusionRegex: { regex: '.*\\.(xml|XML)$', flags: '' }, docType: 'PIC', backupPath: 'C:\\copiatkt\\' },
    { path: 'C:\\NTV', fileNameFiltersToExclude: [], fileExtensionsToInclude: ['xml', 'XML'], localSilentBlacklist: [], forwardingRules: [], inclusionRegex: { regex: '.*\\.(xml|XML)$', flags: '' }, docType: 'NTV', backupPath: 'C:\\copiatkt\\' }
  ]

  const newConfigObj = {
    agencyId: configAgencyId,
    name: configName,
    lastEditedBy: loggedInUser.username,
    lastEdited: DateTime.now().toISO(),
    createdBy: loggedInUser.username,
    createdAt: DateTime.now().toISO(),
    filters: defaultFilters,
    isDeleted: false
  }

  clearFields(setConfigAgencyId, setConfigName)
  await createNewConfig(newConfigObj)
  invalidateQuery('configs')
}

export const deleteViaPatch = async (id, name) => {
  if (name === 'default') {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Impossibile eliminare la config di default.' })
    return
  }
  try {
    await FC.service('configs').patch(id, { isDeleted: true })
    invalidateQuery('configs')
  } catch (error) {
    console.log(error)
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore durante l\'eliminazione del config.' })
  }
}

export const restoreViaPatch = async (id) => {
  try {
    await FC.service('configs').patch(id, { isDeleted: false })
    invalidateQuery('configs')
  } catch (error) {
    console.log(error)
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore durante il ripristino del config.' })
  }
}
